<template>
  <nav class="mobile-menu hide-on-desktop">
    <ul class="elements-list">
      <div class="top-elements">
        <MobileMenuHeader
          :panel-title="panelTitle"
          :config="headerConfig"
          :ihg-access="ihgAccess"
          :ihg-cta-login="ihgCtaLogin"
          :ihg-logo="ihgLogo"
          :partner-exit="partnerExit"
          :partner-logo="partnerLogo"
        />
        <template v-for="item in vueMenuItems">
          <MobileMenuDestinations
            v-if="item.badge === 'continents' || item.badge === 'destinations'"
            :key="item.id"
            :config="item"
          />
          <MobileMenuOffers v-else-if="item.badge === 'offers'" :key="item.id" :config="item" />
          <MobileMenuBookings
            v-else-if="item.badge === 'bookings'"
            :key="item.id"
            :config="item"
            :private-area-config="privateAreaConfig"
          />
          <MobileLastSearches
            v-else-if="item.badge === 'searches' && lastSearchesExist"
            :key="item.id"
            :config="item"
          />
          <MobileMenuItemWithChildren
            v-else-if="item.kind === 'show_sub_menu'"
            :key="item.id"
            :item="item"
            :is-ibp="isIbp"
            :is-user-logged="isUserLogged"
            :logout-text="logoutText"
          ></MobileMenuItemWithChildren>
          <MobileMenuItem
            v-else-if="item.name !== 'Horizons' && item.badge !== 'searches' && !lastSearchesExist"
            :key="item.id"
            :item="item"
          />
          <MobileMenuItem v-else :item="item" :utag-event-info="item.utag_event_info"></MobileMenuItem>
        </template>

        <MobileMenuItem v-if="exitApp" :item="exitApp" />
      </div>

      <div class="bottom-elements">
        <MobileLanguageSelector :config="languageConfig" />
        <MobileCurrencySelector :config="currencyConfig" />
        <AccessibilityButton :config="a11yConfig" />
      </div>
    </ul>
  </nav>
  <!-- .mobile-menu -->
</template>

<script>
import AccessibilityButton from '../AccessibilityButton/AccessibilityButton'
import MobileCurrencySelector from '../MobileCurrencySelector/MobileCurrencySelector'
import MobileLanguageSelector from '../MobileLanguageSelector/MobileLanguageSelector'
import MobileLastSearches from '../MobileLastSearches/MobileLastSearches'
import MobileMenuBookings from '../MobileMenuBookings/MobileMenuBookings'
import MobileMenuDestinations from '../MobileMenuDestinations/MobileMenuDestinations'
import MobileMenuHeader from '../MobileMenuHeader/MobileMenuHeader'
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem'
import MobileMenuItemWithChildren from '../MobileMenuItemWithChildren/MobileMenuItemWithChildren'
import MobileMenuOffers from '../MobileMenuOffers/MobileMenuOffers'

const componentName = 'MobileMenu'

export default {
  name: componentName,
  components: {
    MobileMenuHeader,
    MobileMenuDestinations,
    MobileMenuItem,
    MobileMenuItemWithChildren,
    MobileMenuOffers,
    MobileMenuBookings,
    MobileLastSearches,
    MobileLanguageSelector,
    MobileCurrencySelector,
    AccessibilityButton,
  },
  provide() {
    return {
      backText: this.comeBackText,
    }
  },
  props: {
    comeBackText: String,
    panelTitle: String,
    searchText: String,
    logoutText: String,
    headerConfig: Object,
    exitApp: Object,
    offersConfig: Object,
    hotelsConfig: Object,
    mainMenu: Array,
    bookingsConfig: Object,
    lastSearchesConfig: Object,
    languageConfig: Object,
    currencyConfig: Object,
    a11yConfig: Object,
    privateAreaConfig: Object,
    //IHG
    ihgAccess: String,
    ihgCtaLogin: String,
    ihgLogo: Object,
    //Partner
    partnerExit: String,
    partnerLogo: Object,
    isIbp: {
      type: Boolean,
      default: false,
    },

    vueMenuItems: Array,
  },
  data() {
    return {
      isUserLogged: false,
    }
  },
  computed: {
    lastSearchesExist() {
      const local_last_searches = localStorage.getItem('last_searches')
      return local_last_searches !== null
    },
  },
  mounted() {
    IB.browsing_sessions.readRedis(this.init)
  },
  methods: {
    init() {
      this.isUserLogged = IB.browsing_sessions.isUserLogged()

      if (this.isUserLogged && IB.browsing_sessions !== null && IB.browsing_sessions.getData()) {
        this.user = IB.browsing_sessions.getData().redis_values
      }
    },
  },
}
</script>
